import { getStream } from '../base/selectors';
function getOffsetStream(state, streamId) {
    return getStream(state, streamId);
}
export const getNextOffset = (state, streamId)=>{
    const stream = getOffsetStream(state, streamId);
    const { nextOffset , items  } = stream;
    return nextOffset !== undefined && nextOffset !== null ? nextOffset : items && items.length || 0;
};
export const getPrevOffset = (state, streamId)=>{
    return getOffsetStream(state, streamId).prevOffset || 0;
};
